import React, { Component } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import withSounds from 'containers/withSounds';
import GameCardIcon from 'components/GameCardIcon';
import GameLink from 'components/GameLink';
import TextButton from 'components/TextButton';
import FavoriteIcon from './assets/GameCard-Favorite.png';
import FavoriteIconActive from './assets/GameCard-Favorite-Active.png';
import './GameCard.css';

const GameLinkWithSounds = withSounds({ mouseEnterSound: true })(GameLink);
class GameCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      isFlying: false,
      isFavorite: false
    };

    this.renderFavoritePopUp = this.renderFavoritePopUp.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.target = React.createRef();
  }

  componentWillUnmount() {
    clearTimeout(this.closeOverlay);
  }

  componentDidMount() {
    this.setState({
      isFavorite: this.props.isFavorite
    });
  }

  renderFavoritePopUp(gameName) {
    return <span className="favorites-popover">{gameName}</span>;
  }

  handleAdd(game) {
    this.props.onFavorite(game);
    this.setState({ show: true, isFlying: true, isFavorite: true });
    this.handleCloseOverlay();
    setTimeout(() => {
      this.setState({ isFlying: false });
    }, 3000);
  }

  handleRemove(game) {
    this.props.onRemoveFavorite(game);
    this.setState({ isFavorite: false });
  }

  handleCloseOverlay() {
    this.closeOverlay = setTimeout(() => {
      this.setState({ show: false });
    }, 1000);
  }

  render() {
    const renderHearts = (
      <ul className={`hearts ${this.state.isFlying ? 'flying' : ''}`}>
        {Array.from({ length: 12 }).map((_, index) => (
          <li key={index} className="heart"></li>
        ))}
      </ul>
    );

    const renderFavoriteIcon = (
      <TextButton
        className="favorite-icon"
        value={this.props.level}
        ref={this.target}
        onClick={
          this.state.isFavorite
            ? () => this.handleRemove(this.props.game)
            : () => this.handleAdd(this.props.game)
        }
      >
        <img
          src={this.state.isFavorite ? FavoriteIconActive : FavoriteIcon}
          alt={`${
            this.state.isFavorite
              ? 'Remove game from favorites'
              : 'Add game to favorites'
          }`}
        />
      </TextButton>
    );

    let popOverFavoriteIcon = (
      <div>
        {renderHearts}
        {renderFavoriteIcon}
        <Overlay
          target={this.target.current}
          show={this.state.show}
          placement="left"
        >
          <Tooltip
            className="favorite-notif-tooltip"
            id="favorite-notif-tooltip"
          >
            <div className="favorite-popup">
              <div>{`${this.props.game.displayName} added to favorites!`}</div>
            </div>
          </Tooltip>
        </Overlay>
      </div>
    );

    const disableClick = this.props.isClickDisabled ? ' disable-click' : '';
    const className = 'game-card-container' + disableClick;

    return (
      <div className={className}>
        <GameLinkWithSounds
          game={this.props.game}
          iconComponent={GameCardIcon}
        />
        {popOverFavoriteIcon}
      </div>
    );
  }
}

export default GameCard;
